import React, { useEffect, useRef, useState, useCallback } from 'react';
import SectionBuilder from '../SectionBuilder/SectionBuilder';
import classes from './FormSectionsBuilder.module.css';
import apiGatewayService from '../../../common/services/apiGatewayService';
import Modal from '../Modal/Modal';
import SelectionModalComponent from '../SelectionModal/SelectionModal';
import SectionsSelector from '../SectionsSelector/SectionsSelector';
import validationService from '../../../common/validationService.service';
import localStorageService from '../../../common/services/localStorage.service';
import utilityFunctions from '../../../common/services/utilityFunctions';
import { AWS_API } from '../../../globalVariables';
import FormAdvanceFeatures from '../../FormAdvanceFeatures/FormAdvanceFeatures';
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography, FormGroup, Checkbox, InputLabel, Grid, Toolbar, IconButton } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { Button, Tooltip } from "@mui/material";
import { TextField } from '@mui/material';
import ReorderIcon from '@mui/icons-material/Reorder';
import BackupIcon from '@mui/icons-material/Backup';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddIcon from '@mui/icons-material/Add';
// import ApiIntegrationSelector from '../ApiIntegrationSelector/ApiIntegrationSelector'; // Import the ApiIntegrationSelector component

import ApiIntegrationSelector from '../../ApiIntegrationSelector/ApiIntegrationSelector';
import CustomAlert from '../../CustomAlert/CustomAlert';

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ConfirmationPopup from '../../ConfirmationPopup/ConfirmationPopup';
import DeleteIcon from '@mui/icons-material/Delete';
import AdvancedFeaturePanel from './FormFeatures';

import DataObjectIcon from '@mui/icons-material/DataObject';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import FeedIcon from '@mui/icons-material/Feed';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StartIcon from '@mui/icons-material/Start';
import ErrorIcon from '@mui/icons-material/Error';
import { formNavigationButton } from '../../../common/configurations/json-configurations';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { sectionMoveArrows } from '../../../common/CSS/css-configs';
import CircularLoader from '../../Loader/Loader';

const initialFeatures = [
  // { name: 'Send Forms Via Email', id: 'email', checked: false, placeHolderText: 'enter email' },
  // { name: 'Generate PDF View', id: 'pdf', checked: false, placeHolderText: 'enter text' },
  // { name: 'Custom Submission URL', id: 'submit', checked: false, placeHolderText: 'enter submission url' }
  {name: 'Is Lifecycle Enabled', id: 'lifeCycle', checked: false, placeHolderText: 'Enabl Lifecycle For Form'}
];
const mandatoryHeaders = {
  ID : '',
  formName: '',
  parentBusinessEntity: '',
  businessEntity: '',
  formTypeId: '',
  irisTriageScriptId: '',
  irisTriageScriptDesc: ''
};

const mandatoryHeadersKey = Object.keys(mandatoryHeaders);

const FormSectionsBuilder = ({ auth, form, handleClose, isNew, isEditInput, formIdInput, isSaveForm }) => {
  const [sectionsArray, setSectionsArray] = useState([]);
  const [formHeaders, setFormHeaders] = useState(mandatoryHeaders);
  // const formHeaders = useRef({ID: '', FormName: '', ParentBusinessEntity: '', BusinessEntity: '', FormTypeId: '',IrisTriageScriptDesc: '', IrisTriageScriptId: '' });
  const [submitAPI, setSubmitAPI] = useState('');
  const [isOnlyReadAccess, setIsOnlyReadAccess] = useState(false);
  const [isSubmissionURL, setIsSubmissionURL] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [advanceFeatures, setAdvanceFeatures] = useState(initialFeatures);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [emailToSend, setEmailToSend] = useState('');
  const [sectionSelectorOpen, setSectionSelectorOpen] = useState(false);
  const [isURLModalOpen, setIsURLModalOpen] = useState(false); // State for ApiIntegrationSelector modal

  const [isOpen, setIsOpen] = useState(false);  
  const [inputValue, setInputValue] = useState('');
  const [cogntioUser, setCogntioUser] = useState(null);
  const [apiIntegration, setApiIntegration] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [formId, setFormId] = useState(null);
  const [initialHeaders, setInitialHeaders] = useState(null);
  const [formHeadersProxy, setformHeadersProxy] = useState(false);
  const [renderHeadersFromProxy, setRenderHeadersFromProxy] = useState(false);

  const [displayAlert, setDisplayAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const [checkForErroInSection, setCheckForErroInSection] = useState(false);

  const isFormEdited = useRef(0);
  const [exitFormWarning, setExitFormWarning] = useState(false);

  const [displayHeaders, setDisplayHeaders] = useState(true);
  const [displayFeatures, setDisplayFeatures] = useState(false);
  const [displayForm, setDisplayForm] = useState(false);
  const [sectionArrayCollapse, setSectionArrayCollapse] = useState([]);
  const [formCreationInfo, setFormCreationInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const sectionsRef = useRef([]);


  useEffect(() => {
    if (form?.formConfig?.formHeaders) {
      const formHeaders = form?.formConfig?.formHeaders || {};
      const configMetaData = form?.formConfig?.configMetaData || {};
      const orgUnits = form?.formConfig?.orgUnits || {};
      const targetSystemDetails = orgUnits?.targetSystemDetails || {};
      const createdBy = configMetaData?.createdBy;
      const createdOn = configMetaData?.createdOn;
      setFormCreationInfo({createdBy, createdOn});

      // Build updated header values
      // We need this because we display
      const updatedHeaders = {
        formName: configMetaData?.formName ?? '',
        parentBusinessEntity: orgUnits?.parentBusinessEntity ?? '',
        businessEntity: orgUnits?.businessEntity ?? '',
        formTypeId: configMetaData?.formTypeId ?? '',
        irisTriageScriptId: targetSystemDetails?.irisTriageScriptId ?? '',
        irisTriageScriptDesc: targetSystemDetails?.irisTriageScriptDesc ?? ''
      };

      Object.keys(formHeaders).forEach((key)=>{
        if(!['requestID', 'systemStatus'].includes(key)) {
          updatedHeaders[key] = formHeaders[key]
        }

      });

      setFormHeaders(updatedHeaders);


      sectionsRef.current = Array.from(form.formData.sections)
      setSectionsArray(Array.from(form.formData.sections));
      setSectionArrayCollapse(Array.from(form.formData.sections.map((p)=>false)));
      setSubmitAPI(form.submitApi);
      setInitialHeaders(updatedHeaders);
      if (form?.isEmail) {
        selectedOptions['email'] = true;
        setIsEmail(form.isEmail);
      }
      if (form?.emailToSend) {
        setEmailToSend(form.emailToSend);
      }
      if (form?.apiIntegration){
        selectedOptions['submit'] = true;
        setApiIntegration(form?.apiIntegration);
      }

      if (isEditInput){
        setIsEdit(true);
        setFormId(formIdInput);
      }

    }


    if (form?.formConfig?.configMetaData) {
      advanceFeatures.forEach((lf)=>{
        if (lf?.id === 'lifeCycle') {
          lf['checked'] = form?.formConfig?.configMetaData?.lifeCycle ? form?.formConfig?.configMetaData?.lifeCycle : false ;
          selectedOptions['lifeCycle'] = form?.formConfig?.configMetaData?.lifeCycle ? form?.formConfig?.configMetaData?.lifeCycle : false ;
        }
      })


    }

    const user = localStorageService.getObject('user');
    setCogntioUser(user);
    setIsOnlyReadAccess(utilityFunctions.checkIfOnlyReadAccess(user));
    // console.log("currentCognito User: ", user);
  }, [auth]);

  const handleAdvanceFeatureSelection = (event) => {
    const { name, checked } = event.target;
    setSelectedOptions((prevSelectedOptions) => ({
      ...prevSelectedOptions,
      [name]: checked,
    }));
    setFormAdvanceFeaturesSelection(name, checked);
  };

  const setFormAdvanceFeaturesSelection = (id, checked) => {
    if (id === 'email') {
      setIsEmail(checked);
    } else if (id === 'submit') {
      setIsSubmissionURL(checked);
      // if (checked) {
      //   setIsURLModalOpen(true); // Open the modal when Custom Submission URL is checked
      // } else {
      //   setSubmitAPI(''); // Reset the submit API when unchecked
      // }
    }
  };

  const handleAddSection = () => {
    setSectionsArray([...sectionsArray, { title: "", fields: "" }]);
  };

  const updateSectionsArray = useCallback((section, index, onlyFieldsArray = false) => {
    console.log ("check for updated section here: ", section);
    console.log("index: ", index);
    if(section === undefined){
      const newSectionsArray = sectionsArray.filter((_, ind) => ind !== index);
      setSectionsArray(Array.from(newSectionsArray));
    } else {
      const newSectionsArray = sectionsArray;
      if (onlyFieldsArray){
        newSectionsArray[index]['fields'] = section['fields'];
      }else{
        newSectionsArray[index] = section;
      }

      setSectionsArray(Array.from(newSectionsArray));
    }
    isFormEdited.current = true;
  }, [sectionsArray, setSectionsArray]);


  const handleSubmitForm = async () => {
    if (!validationService.validateFormHeaders(formHeaders)) {
      // alert('Headers can not be empty');
      setAlertMessageAndPopupForms(
        {
          message: 'Error: form headers can not be empty!',
          type: 'error'
        });
    } else {
      const formToSubmit = generateFormForSubmission_v2();
      console.log("formToSubmit: ", formToSubmit);   
      if (formToSubmit !== false) {
        // formToSubmit['formData'] = { 'sections': formToSubmit.sections };
        // delete formToSubmit['sections'];
        const formObject = {
          displayName: formHeaders.ID,
          sections: formToSubmit,
        };
        console.log("This is the form to submit: ", formToSubmit);
        const formValidationResponse = validationService.validateForm(formToSubmit?.formData || []);
        console.log("formValidationResponse: ", formValidationResponse);
        if (!formValidationResponse.isValid) {
          setAlertMessageAndPopupForms(
            {
              message: 'Error: mantory values in sections can not be empty!',
              type: 'error'
            });
            setCheckForErroInSection(true);
            // if(checkForErroInSection){
            //   setCheckForErroInSection(false);
            //   setTimeout(()=>setCheckForErroInSection(true), 100);
            // } else {
            //   setCheckForErroInSection(true);
            // }

        } else {
          try {
            console.log("formToSubmit: ", formToSubmit);
            console.log("isEdit: ", isEdit);
            console.log("formId: ", formId);
            let response;
            setIsLoading(true);
            if (isEdit) {
              formObject['publishStatus'] = 'edited';
              response = await apiGatewayService.putFormsData(formId, formObject);
              setAlertMessageAndPopupForms(
                {
                  message: 'Form Edited Successfully!',
                  type: 'success'
                });
            } else {
              formObject['publishStatus'] = 'created';
              response = await apiGatewayService.postFormsData(formObject);
  
              if (handleClose) {
                handleClose({
                  message: 'Form Created Successfully!',
                  type: 'success'
                });
              }
            }
            console.log(response);
            isFormEdited.current = false;
            setIsLoading(false);
          } catch (error) {
            setIsLoading(false);
            console.log("Error in submitting form: ", error);
            if (error.response) {
              alert('Can not post form: ' + error.response.data.message);
            }
          }
        }
      }
    }
  };

  const generateFormForSubmission = () => {
    if ((submitAPI !== '' || submitAPI !== 'default') && isSubmissionURL) {
      const isValid = isValidUrl(submitAPI);
      if (!isValid) {
        alert("Please enter valid url for submission!");
        return false;
      }
    }

    if ((emailToSend !== '' && isEmail)) {
      const isValidEmail = validateEmail(emailToSend);
      if (!isValidEmail) {
        alert("Please enter valid email address for sending printed forms!");
        return false;
      }
    }
    
    const date = formatDate(new Date());
    formHeaders['configMetaData'] = {
      CreatedOn: initialHeaders['configMetaData'],
      CreatedBy: cogntioUser.attributes.email.toUpperCase(),
      LastEditedOn: date,
      LastEditedBy: cogntioUser.attributes.email.toUpperCase(),
      Status: "Active"
    };
    formHeaders['FormVersion'] = generateFormVersion(new Date());
    console.log("Is edit form: ", isEdit);
    if (isEdit) {
      formHeaders['configMetaData']['CreatedOn'] = initialHeaders['configMetaData']['CreatedOn'];
      formHeaders['configMetaData']['CreatedBy'] = initialHeaders['configMetaData']['CreatedBy'];
    };
    const formToSubmit = {
      formHeaders: formHeaders,
      sections: sectionsArray,
      submitApi: getDefaultSubmitApi(),
    };
    if (isEmail) {
      formToSubmit['isEmail'] = isEmail;
    };
    if (emailToSend !== '' && isEmail) {
      formToSubmit['emailToSend'] = emailToSend;
    };

    if (isNew) {
      formToSubmit['publishStatus'] = 'saved';
    };

    //Add integrationconfig into form. Is Submission URL basicaly controls the api integration
    if (isSubmissionURL && apiIntegration!==null) {
      formToSubmit['apiIntegration'] = apiIntegration;
    };
    return formToSubmit;
  };

  const generateFormForSubmission_v2 = () => {
    const formConfig = {};
    const date = formatDate(new Date());
    formConfig['formHeaders'] = {
      ID: formHeaders['ID'],
      requestID: '',
      systemStatus: '',
      // include all non-mandatory headers
      ...Object.fromEntries(
        Object.entries(formHeaders).filter(([key]) => !mandatoryHeadersKey.includes(key))
      ),
    };
    formConfig['configMetaData'] = {
      formTypeId: formHeaders['formTypeId'],
      formName: formHeaders['formName'],
      createdOn: date,
      createdBy: cogntioUser.attributes.email.toUpperCase(),
      lastEditedOn: date,
      lastEditedBy: cogntioUser.attributes.email.toUpperCase(),
      formVersion: generateFormVersion(new Date()),
      // lifeCycle: initialFeatures.find(item => item.id === 'lifeCycle')?.checked,
      lifeCycle: selectedOptions['lifeCycle'] || false,
      status: "Active"
    };
    formConfig['orgUnits'] = {
      parentBusinessEntity: formHeaders['parentBusinessEntity'],
      businessEntity:  formHeaders['businessEntity'],
      targetSystemDetails: {
          irisTriageScriptId:  formHeaders['irisTriageScriptId'],
          irisTriageScriptDesc: formHeaders['irisTriageScriptDesc']
      }
    };
    console.log("Is edit form: ", isEdit);
    if (isEdit) {
      formConfig['configMetaData']['createdOn'] = formCreationInfo?.createdOn;
      formConfig['configMetaData']['createdBy'] = formCreationInfo?.createdBy;
    };

    const formData = {
      sections: sectionsArray
    };

    const formToSubmit = {
      formConfig: formConfig,
      formData: formData
    };
    if (isEmail) {
      formToSubmit['isEmail'] = isEmail;
    };
    if (emailToSend !== '' && isEmail) {
      formToSubmit['emailToSend'] = emailToSend;
    };

    if (isNew) {
      formToSubmit['publishStatus'] = 'saved';
    };

    //Add integrationconfig into form. Is Submission URL basicaly controls the api integration
    if (isSubmissionURL && apiIntegration!==null) {
      formToSubmit['apiIntegration'] = apiIntegration;
    };
    return formToSubmit;
  };

  function generateFormVersion (date) {
      let versionPrefix = "1.0.0.";
      let currentDate = formatDate(date); // Assuming date is passed as a valid Date object or a timestamp
      
      // Helper function to format the date as 'YYYYMMDDHHMM'
      function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}${month}${day}${hours}${minutes}`;
      }
    
      if (isEdit) {
        // If editing, get the existing version and increment accordingly
        const existingVersion = initialHeaders?.FormVersion || '1.0.0.0';
        let [major, minor, patch] = existingVersion.split('.').map(Number);
    
        // Increment version logic
        if (patch < 9) {
          patch += 1;
        } else if (minor < 9) {
          minor += 1;
          patch = 0;
        } else {
          major += 1;
          minor = 0;
          patch = 0;
        }
    
        versionPrefix = `${major}.${minor}.${patch}.`;
      }
    
      // Return the final version string
      return versionPrefix + currentDate;
  }


  const getDefaultSubmitApi = () => {
    return `${AWS_API}/forms/save/${formHeaders.ID}`;
  };

  function formatDate(date) {
    const pad = (number, length = 2) => String(number).padStart(length, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const milliseconds = pad(date.getMilliseconds(), 3) + '000000';
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  const addOptionsIntoField = (section) => {
    if (section === undefined) {
      handleAddSection();
    } else {
      sectionsArray.push(section);
      const newFieldsArray = Array.from(sectionsArray);
      setSectionsArray(newFieldsArray);
    }
  };

  const updateEmailToSend = (event) => {
    setEmailToSend(event.target.value)
  };

  const updateSubmitURL = (event) => {
    setSubmitAPI(event.target.value);
  };

  const handleAddSubmitURL = (value) => {
    setIsSubmissionURL(value);
    if (!value) {
      setSubmitAPI('');
    }
  };

  function isValidUrl(url) {
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
    return urlPattern.test(url);
  }

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const handleMoveSectionUp = (index) => {
    if (index > 0) {
      const newFieldsArray = [...sectionsArray];
      [newFieldsArray[index - 1], newFieldsArray[index]] = [newFieldsArray[index], newFieldsArray[index - 1]];
      setSectionsArray(newFieldsArray);
    }
  };

  const handleMoveSectionDown = (index) => {
    if (index < sectionsArray.length - 1) {
      const newFieldsArray = [...sectionsArray];
      [newFieldsArray[index + 1], newFieldsArray[index]] = [newFieldsArray[index], newFieldsArray[index + 1]];
      setSectionsArray(newFieldsArray);
    }
  };

  const handleOpenSectionSelector = () => {
    setSectionSelectorOpen(true);
  };

  const handleCustomURLSubmit = (selection) => {
    console.log(selection);
    // setSubmitAPI(selection.selectedIntegration);
    setApiIntegration(selection);
    setIsURLModalOpen(false); // Close the modal after submission
  };

  const openModal = () => {
    console.log("Open the headers modal: ", isOpen );
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSectionSelectorOpen(false);
  };

  const saveModalValue = () => {
    if(inputValue!==""){
        const storedValue = inputValue;
        formHeaders[storedValue] = '';
    };
    setInputValue("");
    closeModal();
  };

  const handleHeaderInputChange = (e) => {
    // formHeaders.current[e.target.name] = e.target.value; //useRef approach
    isFormEdited.current = true;
    formHeaders[e.target.name] = e.target.value;
    setFormHeaders({...formHeaders});
  };

  const setAlertMessageAndPopupForms  = (alertObject) => {
    setDisplayAlert(true);
    setAlertMessage(alertObject.message);
    setAlertType(alertObject.type);
    setTimeout(() => setDisplayAlert(false), 6000);
  };

  const handleFormExitNo = () =>{
    setExitFormWarning(false);
  };

  const handleExitForm = () => {
    console.log("isFormEdited: ", isFormEdited);
    if (isFormEdited.current){
      setExitFormWarning(true);
    } else {
      handleClose();
    }
  };

 const handleDeleteHeader = (key) => {
    delete formHeaders[key]
    setFormHeaders({...formHeaders});
 };


  const setAllFalse = () => {
    setDisplayHeaders(false);
    setDisplayFeatures(false);
    setDisplayForm(false);
  };

  const showHeaders = () => {
    setAllFalse();
    setDisplayHeaders(true);
  };

  const showFeatures = () => {
      setAllFalse();
      setDisplayFeatures(true);
  };

  const showForm = () => {
      setAllFalse();
      setDisplayForm(true);
  };

  const setSectionCollapse = (index) => {
    sectionArrayCollapse[index] = !sectionArrayCollapse[index];
    Array.from([...sectionArrayCollapse]);
  };

  return (
    <div className={classes.FormSectionsContainer}>
      {/* <div className={classes.HeaderContainer}><h2 style={{ padding: '0px', margin: '0px' }}>Form Builder</h2></div> */}
      {exitFormWarning && (
        <ConfirmationPopup
          title={'Form Exit Confirmation'}
          message = {'Saved changes maybe lost.'}
          isOpen={exitFormWarning}
          handleYes={handleClose}
          handleNo={handleFormExitNo}
        />
      )}
      <Toolbar 
        sx={{ 
          // backgroundColor: 'var(--app-color-headings)', 
          backgroundColor: 'white',
          borderRadius: "10px", 
          borderEndEndRadius: '0px', 
          borderEndStartRadius: '0px', 
          padding: '0px', 
          color: 'white', 
          position: 'sticky', // Keeps the toolbar fixed inside the scrollable container
          top: 0,  // Sticks the toolbar to the top of the container
          zIndex: 1000, // Ensures it stays on top of the table
          justifyContent: 'space-between'
        }}>         
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', ml: '-24px' }}>
          <Tooltip title="Headers meta data" arrow >
          <Button
            sx={formNavigationButton(displayHeaders)}
            startIcon={<DataObjectIcon />}
            onClick={showHeaders}
          >
            <Box sx={{ marginTop: '2px' }}>Headers</Box>
          </Button>
          </Tooltip>

          {/* First Arrow */}
          <KeyboardDoubleArrowRightIcon
            sx={{
              mx: 1,
              fontSize: 25,
              color: 'lightgray',
            }}
          />
          <Tooltip title="Additional form features" arrow >
          <Button
            sx={formNavigationButton(displayFeatures)}
            startIcon={<FeaturedPlayListIcon />}
            onClick={showFeatures}
          >
            <Box sx={{ marginTop: '2px' }}>Features</Box>
          </Button>
          </Tooltip>

          {/* Second Arrow */}
          <KeyboardDoubleArrowRightIcon
            sx={{
              mx: 1,
              fontSize: 25,
              color:  'lightgray',
            }}
          />
          
          <Tooltip title = 'Form config containing sections and fields' arrow>
          <Button
            sx={formNavigationButton(displayForm)}
            startIcon={<FeedIcon />}
            onClick={showForm}
          >
            <Box sx={{ marginTop: '2px' }}>Form</Box>
          </Button>
          </Tooltip>

        
        </Box>
        </Box>
        <Box>
          <Button sx={{
            backgroundColor: 'var(--app-color)',
            width: '130px',
            marginRight: '10px',
            ":hover": {
              // backgroundColor: '#F0F4F4',
              backgroundColor: 'var(--button-hover-color)',
              // color: '#2b4252',
            },
            '&.Mui-disabled': {
              backgroundColor: '#e0e0e0',
              color: 'grey',
            },
          }} color="inherit" startIcon={<SaveAltIcon />} onClick={handleSubmitForm} disabled={isOnlyReadAccess}>
            Save
          </Button>
          <Button sx={{
            backgroundColor: 'var(--app-color)',
            width: '130px',
            marginRight: '-23px',
            ":hover": {
              // backgroundColor: '#F0F4F4',
              backgroundColor: 'var(--button-hover-color)',
              // color: '#2b4252',
            },
            '&.Mui-disabled': {
              backgroundColor: '#e0e0e0',
              color: 'grey',
            },
          }} color="inherit" startIcon={<KeyboardBackspaceIcon />} onClick={handleExitForm} disabled={isOnlyReadAccess}>
            Back
          </Button>
        </Box>
      </Toolbar>


        {isLoading && <CircularLoader />}

        {!isLoading && <div>
        {
        displayAlert &&
        <CustomAlert isOpen={displayAlert} message={alertMessage} type={alertType}></CustomAlert>
        }
        { displayHeaders && <Box
          sx={{
            padding: 2,
            mt: '5px',
            mb: 1,
            backgroundColor: '#f1f2f5',
            borderRadius: '10px',
            boxShadow: '0px 1px 1px 1px #d1d1d1',
          }}
        >
          <div>
            <Typography variant="h5" sx={{ flexGrow: 1 }}>
              Headers
            </Typography>
            <Modal
              isOpen={isOpen}
              closeModal={closeModal}
              saveValue={saveModalValue}
              inputValue={inputValue}
              setInputValue={setInputValue}
            />
            <div className={classes.FormFieldContainer}>
              <Grid container spacing={2}>
                {Object.keys(formHeaders).map((key, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={2}
                    key={index}
                    sx={{ position: 'relative' }}
                  >
                    {(key !== 'configMetaData' && key !== 'FormVersion') && (
                      <>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <InputLabel sx={{ mt: 1, mb: 1 }}>{key}</InputLabel>

                          {/* Delete icon for non-mandatory headers */}
                          {!mandatoryHeadersKey.includes(key) && (
                            <Tooltip title="Delete Header">
                              <IconButton
                                size="small"
                                onClick={() => handleDeleteHeader(key)}
                                sx={{
                                  color: 'red',
                                  '&:hover': { backgroundColor: '#ffe5e5' },
                                  mt: 0.5,
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>

                        <TextField
                          type="text"
                          name={key}
                          value={formHeaders[key]}
                          onChange={handleHeaderInputChange}
                          variant="outlined"
                          size="medium"
                          sx={{
                            width: '100%',
                            '& .MuiInputBase-root': {
                              height: 40,
                              backgroundColor: 'white',
                            },
                            '& .MuiOutlinedInput-input': {
                              height: 40,
                              width: '100%',
                            },
                          }}
                        />
                      </>
                    )}
                  </Grid>
                ))}

              </Grid>
              <Tooltip title="Add More Headers">
                <Button
                  onClick={openModal}
                  sx={{
                    mt: '25px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: 0,
                    background: 'transparent',
                    color: 'var(--button-color)',
                    cursor: 'pointer',
                    borderRadius: '10px',
                    ':hover': {
                      backgroundColor: '#F0F4F4',
                      color: 'var(--button-hover-color)',
                    },
                    height: '58px',
                  }}
                >
                  <AddIcon
                    sx={{
                      fontSize: 45,
                      marginTop: 1,
                      marginBottom: '5px',
                      color: 'var(--button-color)',
                      padding: 0,
                    }}
                  />
                </Button>
              </Tooltip>
            </div>
          </div>
        </Box> }
        
        {displayFeatures && <AdvancedFeaturePanel
            advanceFeatures={advanceFeatures}
            selectedOptions={selectedOptions}
            handleAdvanceFeatureSelection={handleAdvanceFeatureSelection}
            updateEmailToSend={updateEmailToSend}
            emailToSend={emailToSend}
            setIsURLModalOpen={setIsURLModalOpen}
            showForm={true}
        />}
                
        {displayForm && <Box 
          sx={{ 
            padding: 2, 
            mt: '5px', 
            mb: 1, 
            // backgroundColor: '#f1f2f5', 
            border: '1px solid #f1f2f5',
            borderRadius: '10px', 
            boxShadow: '0px 1px 1px 1px #d1d1d1' 
          }}
        >
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Sections
        </Typography>
        {sectionsArray.map((section, index) => (
          <div className={classes.fieldContainer} key={index}>
            <div className={classes.ButtonContainerDrag}>
            {/* <Tooltip title={!sectionArrayCollapse[index] ? "Collapse Section" : "Expand Section"}>
              <Button
                onClick={() => setSectionCollapse(index)}
                sx={sectionMoveArrows}
              >
                {!sectionArrayCollapse[index] ? (
                  <UnfoldLessIcon
                    sx={{ fontSize: 30, color: 'var(--app-color)', marginTop: 0, marginBottom: '0px' }}
                  />
                ) : (
                  <UnfoldMoreIcon
                    sx={{ fontSize: 30, color: 'var(--app-color)', marginTop: 0, marginBottom: '0px' }}
                  />
                )}
              </Button>
            </Tooltip> */}

              <Tooltip title="Move Up">
                <Button
                  onClick={() => handleMoveSectionUp(index)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: 0,
                    background: 'transparent',
                    color: 'var(--app-color)',
                    cursor: 'pointer',
                    borderRadius: '10px',
                    ':hover': {
                      backgroundColor: 'transparent',
                      color: 'var(--button-hover-color)',
                    },
                    height: '30px'
                  }}
                >
                  <ArrowDropUpIcon sx={{ fontSize: 40, marginTop: 0, marginBottom: '0px', color: 'var(--app-color)' }} />
                </Button>
              </Tooltip>
                <Tooltip title="Move Down">
                <Button
                  onClick={() => handleMoveSectionDown(index)}
                  sx={sectionMoveArrows}
                >
                  <ArrowDropDownIcon sx={{ fontSize: 40, marginTop: 0, marginBottom: '0px', color: 'var(--app-color)' }} />
                </Button>
              </Tooltip>

            </div>
            <SectionBuilder
              key={index}
              indexSectionsArray={index}
              section={ section }
              updateSectionsArray={updateSectionsArray}
              checkForErroInSection = {checkForErroInSection}
              // title={section.title}
              isForm={true}
              // collapseSection = {!sectionArrayCollapse[index] ? sectionArrayCollapse[index] : true}
            />
          </div>
        ))}

        <div className={classes.SectionsButtonContainer}>
          <Button
            onClick={handleAddSection}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: 0,
              background: 'transparent',
              color: 'var(--icon-button-color-grey)',
              cursor: 'pointer',
              borderRadius: '10px',
              ':hover': {
                backgroundColor: '#F0F4F4',
                color: 'var(--icon-button-color-grey)',
              },
              height: '58px'
            }}
          >
            <AddBoxIcon sx={{ fontSize: 32, marginTop: 1, marginBottom: '5px', color: 'var(--icon-button-color-grey)', padding: 0 }} />
            <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">Add Section</Typography>
          </Button>
          <Button
            onClick={handleOpenSectionSelector}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: 0,
              background: 'transparent',
              color: 'var(--icon-button-color-grey)',
              cursor: 'pointer',
              borderRadius: '10px',
              ':hover': {
                backgroundColor: '#F0F4F4',
                color: 'var(--icon-button-color-grey)',
              },
              height: '58px'
            }}
          >
            <ReorderIcon sx={{ fontSize: 32, marginTop: 1, marginBottom: '5px', color: 'var(--icon-button-color-grey)', padding: 0 }} />
            <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">Select Section</Typography>
          </Button>
        </div>

        {
          !isOnlyReadAccess &&
          <SectionsSelector
            isOpen={sectionSelectorOpen}
            handleClose={closeModal}
            submitOption={addOptionsIntoField}
          />
        }
        </Box>}
      </div> }
      {!isOnlyReadAccess && <button className={classes.Button} onClick={handleSubmitForm}>Save Form</button>}
      { isURLModalOpen &&
        <ApiIntegrationSelector
          isOpen={isURLModalOpen}
          handleClose={() => setIsURLModalOpen(false)}
          submitSelection={handleCustomURLSubmit}
          apiIntegration = {apiIntegration || form?.apiIntegration || null}
      />
      }

    </div>
  );
};

export default FormSectionsBuilder;